import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import { appRoute } from 'app/railways/router/routes';

import { TRoute } from '../../core/route';

export const cols: TEntityGridColumn<TRoute>[] = [
  {
    field: 'id',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: false,
    checkboxSelection: false,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TRoute }) => {
      const path = appRoute.ROUTES.DETAILS.buildPath({ routeId: data.id });

      return <Link to={path}>{data.id}</Link>;
    },
  },
  {
    field: 'number',
    headerName: 'Номер',
    sortable: false,
    colId: 'number',
    comparator: () => 0,
  },
  {
    field: 'nameRu',
    headerName: 'Название',
    sortable: false,
    colId: 'nameRu',
    comparator: () => 0,
  },

  {
    headerName: '',
    sortable: false,
    colId: 'details',
    comparator: () => 0,
    cellRenderer: ({ data }: { data: TRoute }) => {
      const path = appRoute.ROUTES.DETAILS.buildPath({ routeId: data.id });

      return <Link to={path}>Подробнее</Link>;
    },
  },
];
